const month = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]

const year = [
  "2022",
  "2023",
  "2024",
  "2025",
  "2026",
  "2027",
  "2028",
  "2029",
  "2030",
]

const QualityData = [
  {
    indicator: "Patient satisfaction index",
    instruction: "NOT YET STARTED",
    units: "Percentage",
    numeratorLabel: "Sum of Scores achieved",
    numerator: 0,
    denominator: 0,
    denominatorLabel: "Sum of Maximum possible score",
    multiplier: 100,
    indicatorName: "patientSatisfactionIndex",
    outcome: 0,
  },
  {
    indicator: "Percentage of Medication errors",
    instruction: "e.g. Submission  of current month data for this indicator.",
    units: "Percentage",
    numeratorLabel:
      "Total no of medication errors (OPD errors not to be added)",
    numerator: 0,
    denominator: 0,
    denominatorLabel: "Total number of discharges",
    multiplier: 100,
    indicatorName: "medicationError",
    outcome: 0,
  },
  {
    indicator: "Percentage of adverse drug reaction (s)",
    instruction: "e.g. Submission  of current month data for this indicator.",
    units: "Percentage",
    numeratorLabel: "No. of Adverse drug reactions",
    numerator: 0,
    denominator: 0,
    denominatorLabel: "Total number of discharges ",
    multiplier: 100,
    indicatorName: "adverseDrugReaction",
    outcome: 0,
  },
  {
    indicator:
      "Percentage of patients receiving high risk medications developing adverse drug reaction",
    instruction: "e.g. Submission  of current month data for this indicator",
    units: "Percentage",
    numeratorLabel:
      "Number of patients receiving high risk medication who have an adverse drug reaction ",
    numerator: 0,
    denominator: 0,
    denominatorLabel: "Number of patients receiving high risk medications",
    multiplier: 100,
    indicatorName: "patientHighRiskAdverseReaction",
    outcome: 0,
  },
  //from
  {
    indicator: "Percentage of stock outs including emergency drugs",
    units: "Percentage",
    instruction: "e.g. Submission  of current month data for this indicator",
    numeratorLabel: "No. of stock outs of drugs/medicine ",
    numerator: 0,
    denominator: 0,
    denominatorLabel: "No. of drugs listed in hospital formulary list",
    multiplier: 100,
    indicatorName: "stockOutEmergencyDrug",
    outcome: 0,
  },
  {
    indicator: "Percentage of stock outs of consumable items",
    instruction: "e.g. Submission  of current month data for this indicator",
    units: "Percentage",
    numeratorLabel: "No. of stock outs of consumable item",
    numerator: 0,
    denominator: 0,
    denominatorLabel:
      "No. of consumable items listed (emergency / essential items)",
    multiplier: 100,
    indicatorName: "stockOutConsumables",
    outcome: 0,
  },
  {
    indicator: "Percentage of drugs and consumables procured by local purchase",
    instruction: "e.g. Submission  of current month data for this indicator",
    units: "Percentage",
    numeratorLabel: "Number of items purchased by local purchase",
    numerator: 0,
    denominator: 0,
    denominatorLabel:
      "Number of consumable item listed in hospital consumable list + No. of drugs listed in hospital formulary list",
    multiplier: 100,
    indicatorName: "drugsAndConsumablesProcured",
    outcome: 0,
  },
  {
    indicator: "Patient Fall Rate",
    instruction: "e.g. Submission  of current month data for this indicator",
    units: "Percentage",
    numeratorLabel: "No. of patient falls ",
    numerator: 0,
    denominator: 0,
    denominatorLabel: "No. of Discharges",
    multiplier: 100,
    indicatorName: "patientFallRate",
    outcome: 0,
  },
  {
    indicator: "No. of reporting errors/1000 investigations",
    instruction: "e.g. Submission  of current month data for this indicator",
    units: "Percentage",
    numeratorLabel: "No. of reporting errors",
    numerator: 0,
    denominator: 0,
    denominatorLabel: "No. of tests performed",
    multiplier: 1000,
    indicatorName: "reportingErrorPerThousand",
    outcome: 0,
  },
  {
    indicator:
      "Percentage of cases (in-patients) wherein screening for nutritional needs has been done",
    instruction: "e.g. Submission  of current month data for this indicator",
    units: "Percentage",
    numeratorLabel:
      "Number of IPD case records wherein the  nutritional needs has been documented",
    numerator: 0,
    denominator: 0,
    denominatorLabel: "Total number of admissions",
    multiplier: 100,
    indicatorName: "inPatientNutritionalNeedsScreening",
    outcome: 0,
  },
  {
    indicator:
      "Percentage of cases (in-patients) wherein Nursing care plan is documented",
    instruction: "e.g. Submission  of current month data for this indicator",
    units: "Percentage",
    numeratorLabel:
      "Number of IPD case records wherein the  nursing care plan has been documented",
    numerator: 0,
    denominator: 0,
    denominatorLabel: "Total number of admissions",
    multiplier: 100,
    indicatorName: "inPatientNursingCareDocumented",
    outcome: 0,
  },
  {
    indicator:
      "Percentage of medical records not having discharge summary (IPD & Post Procedure cases)",
    instruction: "e.g. Submission  of current month data for this indicator",
    units: "Percentage",
    numeratorLabel: "No. of medical records not having discharge summary",
    numerator: 0,
    denominator: 0,
    denominatorLabel: "No. of IPD & Post Procedure cases",
    multiplier: 100,
    indicatorName: "medicalRecordsWithoutDischargeSummary",
    outcome: 0,
  },
  {
    indicator:
      "Percentage of medical records having incomplete and/or improper consent",
    instruction: "e.g. Submission  of current month data for this indicator",
    units: "Percentage",
    numeratorLabel:
      "No of medical  records having incomplete and improper consent",
    numerator: 0,
    denominator: 0,
    denominatorLabel: "No. of IPD & Post Procedure cases",
    multiplier: 100,
    indicatorName: "medicalRecordsWithoutProperConsent",
    outcome: 0,
  },
  {
    indicator: "Percentage of missing records",
    instruction: "e.g. Submission  of current month data for this indicator",
    units: "Percentage",
    numeratorLabel: "Number of missing record",
    numerator: 0,
    denominator: 0,
    denominatorLabel:
      "Number of discharges + Post procedure records (Records received by MRD)",
    multiplier: 100,
    indicatorName: "missingRecords",
    outcome: 0,
  },
  {
    indicator: "Compliance to Hand hygiene practice",
    instruction: "e.g. Submission  of current month data for this indicator",
    units: "Percentage",
    numeratorLabel: "Total No. of hand hygiene met opportunities",
    numerator: 0,
    denominator: 0,
    denominatorLabel: "Total No. of hand hygiene opportunities",
    multiplier: 100,
    indicatorName: "handHygieneCompliance",
    outcome: 0,
  },
  {
    indicator: "Needle stick injuries",
    instruction: "e.g. Submission  of current month data for this indicator",
    units: "Number",
    numeratorLabel: "No. of needle stick injuries reported ",
    numerator: 0,
    denominator: 0,
    denominatorLabel: "Total No. of IPD discharges",
    multiplier: 100,
    indicatorName: "needleStickInjuries",
    outcome: 0,
  },
  {
    indicator: "Phlebitis",
    instruction: "e.g. Submission  of current month data for this indicator",
    units: "Percentage",
    numeratorLabel: "Total No. of Phlebitis reported",
    numerator: 0,
    denominator: 0,
    denominatorLabel: "Total no . Of IPD discharges",
    multiplier: 100,
    indicatorName: "phlebitis",
    outcome: 0,
  },

  {
    indicator: "Percentage of research activities approved by Ethics committee",
    instruction: "e.g. Submission  of current month data for this indicator",
    units: "Percentage",
    numeratorLabel:
      "Number of research activities approved by ethics committee",
    numerator: 0,
    denominator: 0,
    denominatorLabel:
      "Number of research protocols submitted to ethics committee ",
    multiplier: 100,
    indicatorName: "researchPercentage",
    outcome: 0,
  },
  {
    indicator: "Percentage of patients withdrawing from clinical research",
    instruction: "e.g. Submission  of current month data for this indicator",
    units: "Percentage",
    numeratorLabel: "Number of patients withdrawing from research study ",
    numerator: 0,
    denominator: 0,
    denominatorLabel: " Number of patients originally enrolled in the study",
    multiplier: 100,
    indicatorName: "patientsWithdrawingFromCR",
    outcome: 0,
  },
  {
    indicator:
      "Percentage of protocol violations/deviations in clinical research study",
    instruction: "e.g. Submission  of current month data for this indicator",
    units: "Percentage",
    numeratorLabel:
      "Incidence of protocol violations/deviations observed in clinical research study ",
    numerator: 0,
    denominator: 0,
    denominatorLabel: "Number of observations made",
    multiplier: 100,
    indicatorName: "clinicalResearchStudyDeviations",
    outcome: 0,
  },
  {
    indicator:
      "Percentage of serious events in clinical research study reported to ethics committee",
    instruction: "e.g. Submission  of current month data for this indicator",
    units: "Percentage",
    numeratorLabel:
      "Number of serious adverse events reported to ethics committee",
    numerator: 0,
    denominator: 0,
    denominatorLabel: " Number of serious adverse events identified",
    multiplier: 100,
    indicatorName: "clinicalResearchStudySeriousEthicsEvents",
    outcome: 0,
  },
]

export { month, year, QualityData }
